import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-white w-full text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-10 text-black font-medium text-3xl mb-16" }, "404 ~ Sayfa bulunamadı!", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Anasayfaya Dön")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, { to: '/' }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, { type: "primary" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}